import {Container, Header, Tab} from "semantic-ui-react";
import {PS_URLS, useCompany} from "../core";
import { EnergyDeviceVendorsIntegration } from './integrations/energy-devices/EnergyDeviceVendorsIntegration';
import { useHistory, useParams } from 'react-router-dom';
import { ControlledTab } from "../ui/ControlledTab";
export function UserIntegrations() {
  const history = useHistory();
  let company = useCompany()
  let companyName = company.name;
  let companyId = company.id;
  let subPage = useParams<{subPage: string}>().subPage || 'energy-device-vendors';

  const panes = [
    { menuItem: 'Energy Device Vendors', render: () => <Tab.Pane>{<EnergyDeviceVendorsIntegration companyId={companyId} />}</Tab.Pane> },
  ]

  return (
    <Container

      header={"Integration"}>
      <Header>
                                                                             {companyName}
      </Header>
      <ControlledTab panes={panes} subPage={subPage}
      onChange={(activeItemString: string) => {
        history.push(PS_URLS(companyId).amUserIntegrations(activeItemString))
      }}
      />
    </Container>
  );
}